import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";

export default function ReportButtonForm({
  show,
  onHide,
  onConfirm,
  title = "Raport",
  isFromDateTime = false,
  isToDateTime = false,
  isLocations = [],
  isIncludeEmpty = false,
}) {
  const [fromDateTime, setFromDateTime] = useState("");
  const [toDateTime, setToDateTime] = useState("");
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [includeEmpty, setIncludeEmpty] = useState(false);

  const format = "YYYY-MM-DD HH:mm:ss";
  useEffect(() => {
    if (show) {
      const weekAgo = moment().subtract(7, "days").startOf("day");
      const now = moment().endOf("day");
      setFromDateTime(weekAgo.format(format));
      setToDateTime(now.format(format));
    }
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      fromCreateDateTime: moment(fromDateTime).format("YYYY-MM-DD HH:mm:ss"),
      toCreateDateTime: moment(toDateTime).format("YYYY-MM-DD HH:mm:ss"),
      includeEmpty,
    };
    if (locationId) formData.locationId = locationId;
  onConfirm(formData);
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form id="report-form" onSubmit={handleSubmit}>
          {isFromDateTime && (
            <div className="form-group">
              <label>Od (data i czas):</label>
              <input
                type="datetime-local"
                className="form-control"
                value={fromDateTime}
                onChange={(e) => setFromDateTime(e.target.value)}
                required
              />
            </div>
          )}

          {isToDateTime && (
            <div className="form-group">
              <label>Do (data i czas):</label>
              <input
                type="datetime-local"
                className="form-control"
                value={toDateTime}
                onChange={(e) => setToDateTime(e.target.value)}
                required
              />
            </div>
          )}

          {isLocations?.length>0 &&(
            <div className="form-group">
              <label>Lokalizacja</label>
              <input
                className="form-control"
                list="LocationsList"
                placeholder="Wybierz lokalizację"
                value={locationName}
                onChange={(e) => {
                  setLocationName(e.target.value)
                  const match = isLocations.find(l => l.Name === locationName)
                  setLocationId(match ? match.LocationId : null)}}
              />
              <datalist id="LocationsList">
                {isLocations.map(l => (
                  <option key={l.LocationId} value={l.Name} />
                ))}
              </datalist>
            </div>
          )}

          {isIncludeEmpty && (
            <div className="form-group form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="includeEmpty"
                checked={includeEmpty}
                onChange={(e) => setIncludeEmpty(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="includeEmpty">
                Eksportować puste dane?
              </label>
            </div>
          )}
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          Anuluj
        </Button>
        <Button variant="success" size="sm" type="submit" form="report-form">
          Eksportuj
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
